import { compose, hoistStatics, withState, withHandlers, lifecycle, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import DocPreviewModal from './DocPreviewModal';
import DocumentService from '../../../services/document.service';

const loadData = props => async (id) => {
  const { setItem, history } = props;
  const document = await DocumentService.get(id);
  if (!document.errors) {
    setItem(document);
  } else {
    history.push('/modules/docs/manage');
  }
};

const toggleModalCom = props => (e, activeStatus) => {
  if (e)e.preventDefault();
  props.setActiveModalCom(activeStatus);
};

const enhance = compose(
  translate('portal'),
  withState('commentCount', 'setCommentCount', 0),
  withState('activeModalCom', 'setActiveModalCom', false),
  withState('item', 'setItem', null),
  lifecycle({
    async componentDidMount() {
      const { props } = this;
      if (props.match && props.match.params.id) {
        await loadData(props)(props.match.params.id);
      }
    },
    async shouldComponentUpdate(nextProps) {
      if (nextProps.match.params.id !== this.props.match.params.id) {
        await loadData(nextProps)(nextProps.match.params.id);
      }
    },
  }),
  withHandlers({
    toggleModalCom,
  }),
);

export default withRouter(hoistStatics(enhance)(DocPreviewModal));



// WEBPACK FOOTER //
// ./src/components/modalWindows/documentPreviewModal/index.js